import {Component, OnDestroy, OnInit} from '@angular/core';
import {ReservationService} from '../../services/reservation.service';
import {Utilities} from '../../utils/utilities';
import {RestaurantService} from '../../services/restaurant.service';
import {MyStorageService} from '../../services/my-storage.service';
import {ActivatedRoute, Router} from '@angular/router';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {Constants} from '../../utils/constants';
import {
  RestaurantSelectModalComponent
} from '../../components/restaurant-select-modal/restaurant-select-modal.component';
import {StompSockService, StompSockWebSocket, WsCommand} from '@oril/ng-stomp-sock';
import {BroadcastPayload, WebsocketNotificationService} from '../../services/websocket-notification.service';
import {filter} from 'rxjs/operators';
import swal from 'sweetalert2';
import {TranslateService} from '@ngx-translate/core';
import {FoodList, FoodListElement, FoodListKey} from '../../models/food-list.interface';
import {KeycloakService} from 'keycloak-angular';
import {AttachmentUrlService} from "../../services/attachment-url.service";
import {ReservationDateOption} from "../../components/header/header.component";

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit, OnDestroy {

  reservations: any[];
  restaurants: any[];
  selectedRestaurantHistoryId: any;
  public activityWS: StompSockWebSocket;
  private loggedInUser: any;
  reservationDate: ReservationDateOption = null;

  constructor(private reservationService: ReservationService,
              private restaurantService: RestaurantService,
              private myStorageService: MyStorageService,
              private route: ActivatedRoute,
              private router: Router,
              private webSocketService: StompSockService,
              private wsNotificationService: WebsocketNotificationService,
              private translate: TranslateService,
              private modalService: BsModalService,
              private attachmentUrlService: AttachmentUrlService, private keycloakService: KeycloakService) {
    this.keycloakService.getKeycloakInstance().loadUserProfile().then(result => {
      this.loggedInUser = result;
    });
  }

  async ngOnInit() {
    this.reservationDate = this.myStorageService.getFromCookiesWithParse('reservationDate', new ReservationDateOption(true, Utilities.dateToBackendString(new Date())));
    this.checkForRestaurant();
  }

  loadData() {
    this.reservationService.getTypeCalendarByRestaurantHistoryIdAndReservationDate(this.selectedRestaurantHistoryId, this.reservationDate.dateString, false).subscribe(data => {
      this.reservations = data;
      this.createFoodListForKitchen();
      this.handleArchivedAndEditedReservations();
      this.scrollTo();
    });
  }

  createFoodListForKitchen() {
    this.reservations.forEach(reservation => {
      let foodList: FoodList[] = [];
      reservation.guests.forEach(guest => {
        guest.preorderedDiys.forEach(guestDiy => {
          let categoryFind = foodList.find(element => element.category.diyTypeId == guestDiy.diy.type.id);
          guestDiy.diy.traySrc = this.getAttachmentSrc(guestDiy.diy.tray);

          if (!categoryFind) {
            foodList.push(new FoodList(new FoodListKey(guestDiy.diy.type.localizations[this.translate.currentLang].name, guestDiy.diy.type.id, guestDiy.diy.type.orderNumber), []));
          }
          foodList.forEach(element => {
            if (element.category.diyTypeId == guestDiy.diy.type.id) {
              const diyFind = element.diyList.find(diyElement => diyElement.diyId == guestDiy.diy.id);
              if (!diyFind) {
                const foodListElement = new FoodListElement(guestDiy.diy.localizations[this.translate.currentLang].name, guestDiy.diy.id, guestDiy.id, guestDiy.status, this.getAttachmentSrc(guestDiy.diy.tray));
                element.diyList.push(foodListElement);
              } else {
                element.diyList.forEach(diyListElement => {
                  if (diyListElement.diyId == guestDiy.diy.id) {
                    diyListElement.guestDiyIds.push(guestDiy.id);
                    diyListElement.status = guestDiy.status;
                    diyListElement.count += 1;
                  }
                });
              }
            }
          });
        });
      });
      reservation['foodListForKitchen'] = this.sortFoodList(foodList);
    });
  }

  private checkForRestaurant() {
    this.restaurants = this.restaurantService.getUsersRestaurants();
    if (this.restaurants == null) {
      this.loadRestaurants();
    } else {
      this.processRestaurants();
    }
  }

  private loadRestaurants() {
    this.restaurantService.getAllForUser().subscribe(restaurants => {
      this.restaurants = restaurants;
      this.processRestaurants();
    });
  }

  private processRestaurants() {
    let savedRestaurantId = this.myStorageService.getFromCookies(Constants.STORAGE_KEYS.RESTAURANT, null);
    savedRestaurantId = this.restaurants.find(restaurant => restaurant.historyId == savedRestaurantId) ? savedRestaurantId : null;
    if (!savedRestaurantId) {
      if (this.restaurants.length < 1) {
        this.router.navigate(['/access-denied']);
      } else if (this.restaurants.length == 1) {
        this.myStorageService.saveToCookies(Constants.STORAGE_KEYS.RESTAURANT, this.restaurants[0].historyId);
        this.myStorageService.saveToCookies(Constants.STORAGE_KEYS.LANGUAGE, this.restaurants[0].defaultLanguage);
        window.location.reload();
      } else {
        const config = Utilities.createModalConfig({restaurants: this.restaurants}, 'modal-sm');
        const modalRef: BsModalRef = this.modalService.show(RestaurantSelectModalComponent, config);
        modalRef.content.onCloseWithResponse.subscribe(response => {
          window.location.reload();
        });
      }
    } else {
      this.selectedRestaurantHistoryId = savedRestaurantId;
    }
    if (this.selectedRestaurantHistoryId) {
      this.connectToAPI();
      this.loadData();
    }
  }

  public connectToAPI() {
    this.webSocketService.connected$
      .pipe(filter(connected => !!connected))
      .subscribe(() => this.connectToEndpoint());
  }

  private connectToEndpoint() {
    this.activityWS = this.webSocketService.getWebSocket(this.wsNotificationService.reservationEndpoint + "/" + this.selectedRestaurantHistoryId);
    this.subscribeToReservation();
  }

  private subscribeToReservation() {
    this.activityWS.on<any>(WsCommand.MESSAGE)
      .subscribe((response: BroadcastPayload) => {
        const type = this.wsNotificationService.reloadKey.find(key => key == response.type);
        console.log(type);
        if (type != undefined) {
          if (this.loggedInUser.email == response.attribute.modifier.email) {
            this.loadData();
          } else if (response.attribute.reservationStatus == "ACCEPTED"
            || response.attribute.reservationStatus == "NOT_ARRIVED"
            || response.attribute.reservationStatus == "SUCCESS") {
            swal.fire({
              title: this.translate.instant('general.info'),
              text: this.translate.instant('reservation.refresh'),
              timer: 3000,
              showConfirmButton: false
            }).then(res => {
              this.loadData();
            });
          }
        }
      });
  }

  private handleArchivedAndEditedReservations() {
    let archiveList = this.reservationService.getReservationArchiveAndIsEditList();
    this.reservations.forEach(reservation => {
      let reservationFind = archiveList.find(res => res.id == reservation.id);
      if (reservationFind) {
        reservation['archived'] = reservationFind.archived;
        reservation['isEdit'] = reservationFind.isEdit;
      } else {
        reservation['archived'] = false;
        reservation['isEdit'] = false;
      }
    });
    this.reservationService.createAndSaveReservationArchiveAndIsEditList(this.reservations);
  }

  private sortFoodList(foodList: FoodList[]) {
    foodList = foodList.sort((x, y) => {
      if (x.category.orderNumber > y.category.orderNumber) {
        return 1;
      }
      if (x.category.orderNumber < y.category.orderNumber) {
        return -1;
      }
      return 0;
    });
    foodList.forEach(element => {
      element.diyList = element.diyList.sort((x, y) => {
        if (x.diyId > y.diyId) {
          return 1;
        }
        if (x.diyId < y.diyId) {
          return -1;
        }
        return 0;
      });
    });
    return foodList;
  }

  ngOnDestroy(): void {
    this.webSocketService.unsubscribe(this.wsNotificationService.reservationEndpoint + "/" + this.selectedRestaurantHistoryId);
  }

  scrollTo() {
    setTimeout(() => {
      const element = document.querySelector('#' + this.route.snapshot.fragment);
      if (element) {
        element.scrollIntoView();
      }
    }, 300);
  }

  getAttachmentSrc(tray: any) {
    if (tray != undefined) {
      return this.attachmentUrlService.getScaleWidthImageUrl(tray.localization, 600);
    }

    return "assets/images/placeholder.jpg";
  }

}
